import { Link } from "react-router-dom";
import NetworkGraph from "../components/NetworkGraph";
import Reveal from "../components/Reveal";
import { IconTarget, IconRocket, IconBulb } from "../components/Icons";

export default function Sobre() {
  return (
    <>
      {/* ═══════════════ ABERTURA ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="hero" className="page-hero__network" />
        <div className="container">
          <div className="breadcrumb animate-up">
            <Link to="/">Início</Link>
            <span>/</span>
            <span>Sobre nós</span>
          </div>
          <div className="tag animate-up animate-up--d1">Quem somos</div>
          <h1
            className="section-title animate-up animate-up--d2"
            style={{ fontSize: "clamp(36px,5vw,56px)", maxWidth: "700px" }}
          >
            Tecnologia que conecta.
            <br />
            <span className="text-blue">Soluções que transformam.</span>
          </h1>
          <p
            className="animate-up animate-up--d3"
            style={{
              fontSize: "18px",
              color: "var(--text-secondary)",
              maxWidth: "600px",
              lineHeight: "1.7",
              marginTop: "16px",
            }}
          >
            Desde 2007, a sepolTECH é o parceiro de TI que pequenas e médias
            empresas de São Paulo escolhem para cuidar de sua tecnologia com
            seriedade, proatividade e resultado.
          </p>
        </div>
      </section>

      {/* ═══════════════ HISTÓRIA ═══════════════ */}
      <section className="section">
        <div className="container">
          <div className="grid-2col-hero">
            <Reveal>
              <div className="tag">Nossa história</div>
              <h2 className="section-title">
                De 2007 até hoje:
                <br />
                <span className="text-blue">evolução constante</span>
              </h2>
              <p
                style={{
                  color: "var(--text-secondary)",
                  lineHeight: "1.8",
                  marginBottom: "20px",
                }}
              >
                A sepolTECH nasceu em São Paulo com uma missão clara: oferecer
                suporte e soluções de TI acessíveis para empresas que não
                tinham condições de manter um departamento interno de
                tecnologia.
              </p>
              <p
                style={{
                  color: "var(--text-secondary)",
                  lineHeight: "1.8",
                  marginBottom: "20px",
                }}
              >
                Com o tempo, crescemos junto com nossos clientes. Passamos de
                empresa de manutenção e suporte para um{" "}
                <strong style={{ color: "var(--text-primary)" }}>
                  Provedor de Serviços Gerenciados (MSP)
                </strong>{" "}
                completo — com portfólio próprio de produtos em nuvem,
                infraestrutura gerenciada e segurança corporativa.
              </p>
              <p style={{ color: "var(--text-secondary)", lineHeight: "1.8" }}>
                Hoje, o ecossistema sepolTECH cobre desde a gestão do endpoint
                até a hospedagem, backup, comunicação e gestão empresarial —
                tudo em um único parceiro confiável.
              </p>
            </Reveal>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "16px" }}
            >
              <Reveal
                className="card"
                delay={0}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  padding: "24px",
                }}
              >
                <div
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: "26px",
                    fontWeight: 700,
                    color: "var(--brand-blue)",
                    minWidth: "72px",
                  }}
                >
                  2007
                </div>
                <div>
                  <div style={{ fontWeight: 700, marginBottom: "4px" }}>
                    Fundação em São Paulo
                  </div>
                  <div style={{ fontSize: "13px", color: "var(--text-muted)" }}>
                    Suporte e manutenção para PMEs paulistanas
                  </div>
                </div>
              </Reveal>
              <Reveal
                className="card"
                delay={0.08}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  padding: "24px",
                }}
              >
                <div
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: "26px",
                    fontWeight: 700,
                    color: "var(--brand-blue)",
                    minWidth: "72px",
                  }}
                >
                  2015
                </div>
                <div>
                  <div style={{ fontWeight: 700, marginBottom: "4px" }}>
                    Primeiros serviços em nuvem
                  </div>
                  <div style={{ fontSize: "13px", color: "var(--text-muted)" }}>
                    Início da oferta de hospedagem e e-mail corporativo
                  </div>
                </div>
              </Reveal>
              <Reveal
                className="card"
                delay={0.16}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  padding: "24px",
                }}
              >
                <div
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: "26px",
                    fontWeight: 700,
                    color: "var(--brand-blue)",
                    minWidth: "72px",
                  }}
                >
                  2020
                </div>
                <div>
                  <div style={{ fontWeight: 700, marginBottom: "4px" }}>
                    Expansão do portfólio
                  </div>
                  <div style={{ fontSize: "13px", color: "var(--text-muted)" }}>
                    sepolDRIVE, sepolBACKUP, sepolCHAT e sepolSECURITY
                  </div>
                </div>
              </Reveal>
              <Reveal
                className="card"
                delay={0.24}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  padding: "24px",
                  background:
                    "linear-gradient(135deg,rgba(0,102,255,.1),rgba(0,58,153,.03))",
                  borderColor: "rgba(0,102,255,.25)",
                }}
              >
                <div
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: "26px",
                    fontWeight: 700,
                    color: "var(--brand-blue)",
                    minWidth: "72px",
                  }}
                >
                  2025
                </div>
                <div>
                  <div style={{ fontWeight: 700, marginBottom: "4px" }}>
                    sepolTECH MSP
                  </div>
                  <div style={{ fontSize: "13px", color: "var(--text-muted)" }}>
                    Posicionamento oficial como Managed Service Provider
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════ MISSÃO VISÃO VALORES ═══════════════ */}
      <section className="section section--alt">
        <div className="container">
          <Reveal className="text-center" style={{ marginBottom: "56px" }}>
            <div className="tag">Propósito</div>
            <h2 className="section-title">
              Missão, Visão <span className="text-blue">e Valores</span>
            </h2>
          </Reveal>
          <div className="grid-3" style={{ gap: "24px" }}>
            <Reveal
              className="card"
              delay={0}
              style={{
                "--accent": "#0066FF",
                textAlign: "center",
                padding: "40px 32px",
              }}
            >
              <div
                className="purpose-card__icon"
                style={{ background: "rgba(0,102,255,.12)", color: "#0066FF" }}
              >
                <IconTarget />
              </div>
              <h3
                style={{
                  fontFamily: "var(--font-display)",
                  fontSize: "18px",
                  fontWeight: 700,
                  marginBottom: "16px",
                  color: "var(--brand-blue)",
                }}
              >
                Missão
              </h3>
              <p
                style={{
                  fontSize: "15px",
                  color: "var(--text-secondary)",
                  lineHeight: "1.7",
                }}
              >
                Conectar soluções tecnológicas que impulsionem o crescimento
                e a eficiência das empresas, sendo um parceiro confiável e
                estratégico em TI.
              </p>
            </Reveal>
            <Reveal
              className="card"
              delay={0.08}
              style={{
                "--accent": "#4D94FF",
                textAlign: "center",
                padding: "40px 32px",
              }}
            >
              <div
                className="purpose-card__icon"
                style={{ background: "rgba(77,148,255,.12)", color: "#4D94FF" }}
              >
                <IconRocket />
              </div>
              <h3
                style={{
                  fontFamily: "var(--font-display)",
                  fontSize: "18px",
                  fontWeight: 700,
                  marginBottom: "16px",
                  color: "var(--brand-blue-light)",
                }}
              >
                Visão
              </h3>
              <p
                style={{
                  fontSize: "15px",
                  color: "var(--text-secondary)",
                  lineHeight: "1.7",
                }}
              >
                Ser reconhecida como o principal ecossistema de TI gerenciada
                para PMEs em São Paulo, referência em inovação, qualidade e
                atendimento humanizado.
              </p>
            </Reveal>
            <Reveal
              className="card"
              delay={0.16}
              style={{
                "--accent": "#0EA5E9",
                textAlign: "center",
                padding: "40px 32px",
              }}
            >
              <div
                className="purpose-card__icon"
                style={{ background: "rgba(14,165,233,.12)", color: "#0EA5E9" }}
              >
                <IconBulb />
              </div>
              <h3
                style={{
                  fontFamily: "var(--font-display)",
                  fontSize: "18px",
                  fontWeight: 700,
                  marginBottom: "16px",
                  color: "var(--info)",
                }}
              >
                Valores
              </h3>
              <p
                style={{
                  fontSize: "15px",
                  color: "var(--text-secondary)",
                  lineHeight: "1.7",
                }}
              >
                Transparência, proatividade, excelência técnica,
                comprometimento com o resultado do cliente e evolução
                contínua em um setor que nunca para.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ═══════════════ DIFERENCIAIS ═══════════════ */}
      <section className="section">
        <div className="container">
          <div className="grid-2col-hero">
            <Reveal>
              <div className="tag">Nossos diferenciais</div>
              <h2 className="section-title">
                Por que as empresas
                <br />
                <span className="text-blue">escolhem a sepolTECH</span>
              </h2>
              <div className="feature-list" style={{ marginTop: "32px" }}>
                <div className="feature-item">
                  <div className="feature-item__icon">✓</div>
                  <div>
                    <strong style={{ color: "var(--text-primary)" }}>Gestão proativa</strong>
                    <br />
                    <span style={{ fontSize: "14px" }}>
                      Monitoramos sua infraestrutura 24/7 e agimos antes que
                      problemas virem incidentes.
                    </span>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-item__icon">✓</div>
                  <div>
                    <strong style={{ color: "var(--text-primary)" }}>
                      Ecossistema completo
                    </strong>
                    <br />
                    <span style={{ fontSize: "14px" }}>
                      Hospedagem, backup, segurança, comunicação e ERP —
                      tudo em um único parceiro.
                    </span>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-item__icon">✓</div>
                  <div>
                    <strong style={{ color: "var(--text-primary)" }}>
                      Atendimento humanizado
                    </strong>
                    <br />
                    <span style={{ fontSize: "14px" }}>
                      Equipe técnica que fala a língua do seu negócio, não
                      só de TI.
                    </span>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-item__icon">✓</div>
                  <div>
                    <strong style={{ color: "var(--text-primary)" }}>
                      Parcerias de primeiro nível
                    </strong>
                    <br />
                    <span style={{ fontSize: "14px" }}>
                      Bitdefender, Bruning Sistemas e infraestrutura cloud
                      de confiança.
                    </span>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-item__icon">✓</div>
                  <div>
                    <strong style={{ color: "var(--text-primary)" }}>
                      Presença local em SP
                    </strong>
                    <br />
                    <span style={{ fontSize: "14px" }}>
                      Atendimento presencial em São Paulo quando você
                      precisa de alguém no escritório.
                    </span>
                  </div>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.1} className="grid-2" style={{ gap: "16px" }}>
              <div className="card" style={{ textAlign: "center", padding: "32px 20px" }}>
                <div
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: "34px",
                    fontWeight: 700,
                    color: "var(--brand-blue)",
                  }}
                >
                  +17
                </div>
                <div
                  style={{
                    fontSize: "13px",
                    color: "var(--text-muted)",
                    marginTop: "8px",
                  }}
                >
                  Anos de mercado
                </div>
              </div>
              <div className="card" style={{ textAlign: "center", padding: "32px 20px" }}>
                <div
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: "34px",
                    fontWeight: 700,
                    color: "var(--brand-blue)",
                  }}
                >
                  MSP
                </div>
                <div
                  style={{
                    fontSize: "13px",
                    color: "var(--text-muted)",
                    marginTop: "8px",
                  }}
                >
                  Serviços gerenciados
                </div>
              </div>
              <div className="card" style={{ textAlign: "center", padding: "32px 20px" }}>
                <div
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: "34px",
                    fontWeight: 700,
                    color: "var(--brand-blue)",
                  }}
                >
                  6+
                </div>
                <div
                  style={{
                    fontSize: "13px",
                    color: "var(--text-muted)",
                    marginTop: "8px",
                  }}
                >
                  Produtos em nuvem
                </div>
              </div>
              <div
                className="card"
                style={{
                  textAlign: "center",
                  padding: "32px 20px",
                  background:
                    "linear-gradient(135deg,rgba(0,102,255,.12),rgba(0,58,153,.04))",
                  borderColor: "rgba(0,102,255,.25)",
                }}
              >
                <div
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: "34px",
                    fontWeight: 700,
                    color: "var(--brand-blue)",
                  }}
                >
                  SP
                </div>
                <div
                  style={{
                    fontSize: "13px",
                    color: "var(--text-muted)",
                    marginTop: "8px",
                  }}
                >
                  São Paulo
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ═══════════════ CTA ═══════════════ */}
      <section className="section section--alt">
        <div className="container">
          <div className="cta-banner">
            <h2 className="cta-banner__title">Vamos conversar sobre a TI da sua empresa?</h2>
            <p className="cta-banner__sub">Conheça como a sepolTECH pode ser o parceiro de tecnologia que seu negócio precisa.
            </p>
            <div className="cta-banner__actions">
              <Link to="/contato" className="btn btn-primary">Falar com a equipe →</Link>
              <Link to="/servicos/servicos" className="btn btn-outline">Ver serviços</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
